class QuickAdd extends HTMLElement {
  constructor() { 
    super();
    this.productWrapperSelector = '[js-product-wrapper]';
    this.productQuickaddBtnSelector = '[js-quick-add-btn]'
    

    
    this.querySelectorAll(this.productQuickaddBtnSelector).forEach(productQuickaddBtn => {
        productQuickaddBtn.addEventListener('click',()=>{
            const parent = productQuickaddBtn.closest(this.productWrapperSelector); 
            const loaderIcon = parent?.querySelector('[js-spinner-icon]');
            const productUrl = parent?.dataset.productUrl;

            loaderIcon.classList.remove('hidden');
            productQuickaddBtn.style.opacity="0.3";
            document.body.classList.add('overflow-hidden');

            this.renderProduct(productUrl,productQuickaddBtn,loaderIcon);
        })
    }) 
    
  }
  async renderProduct(productUrl, productQuickaddBtn,loaderIcon) {
        try {
            
            const response = await fetch(`${location.origin}${productUrl}`);
                
            const html = await response.text();
            const html_ = new DOMParser().parseFromString(html, "text/html");
            const productGrid = html_.querySelector('[js-product-info]');
            
            if (productGrid) {
                const targetElement = document.querySelector('[js-quick-add-product-data]');
                
                if (targetElement) {
                  targetElement.replaceChildren(productGrid);
                }
                const quickAddPopup= document.querySelector('[js-quick-add-popup]')
                quickAddPopup?.classList.add('active')
            }
            document.dispatchEvent(new CustomEvent('product-size-chart:init'));
            
               
        } catch (error) {
            console.error('Error fetching product details:', error);
        } finally {
          loaderIcon.classList.add('hidden');
          productQuickaddBtn.style.opacity="1";
        }
      }
  
}
customElements.define('quick-add', QuickAdd)

document.addEventListener('DOMContentLoaded',function(){
    const quickAddPopupCloseEles = document.querySelectorAll('[js-quick-add-popup-close-ele]')
    const quickAddPopup= document.querySelector('[js-quick-add-popup]')
    quickAddPopupCloseEles.forEach(item => {
        item.addEventListener('click', ()=>{
            quickAddPopup?.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        })
    });
})